import { FC, useState } from "react";
import {
  AlternativeTransportItinerary,
  AlternativeTransportItineraryStop,
  StopReference,
  VehicleStatus,
} from "shared/types/alternativeTransport";
import { ChangeActualTime } from "features/CenterContent/VehicleDetails/AlternativeTransportDetails/Itinerary/ChangeActualTime";
import { BusStopRow } from "features/CenterContent/VehicleDetails/AlternativeTransportDetails/BusStopRow";

type Props = {
  id: string;
  travelDate: Date | null;
  itinerary: AlternativeTransportItinerary | null;
  vehicleStatus: VehicleStatus;
  distributionStopReferences: Array<StopReference>;
};

export const BusStopTableBody: FC<Props> = ({
  id,
  travelDate,
  itinerary,
  vehicleStatus,
  distributionStopReferences,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedStop, setSelectedStop] =
    useState<AlternativeTransportItineraryStop | null>(null);

  const allStops: AlternativeTransportItineraryStop[] = (() => {
    if (!itinerary) return [];
    if (itinerary.returnStops !== null && itinerary.returnStops.length > 0) {
      return itinerary.stops.concat(itinerary.returnStops.slice(1));
    }
    return itinerary.stops;
  })();

  if (!allStops.length) {
    return null;
  }

  const lastArrivedIndex = allStops
    .map((stop) => !!stop.actualArrivalTime)
    .lastIndexOf(true);

  const openModalForStop = (stop: AlternativeTransportItineraryStop) => {
    setSelectedStop(stop);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedStop(null);
  };

  return (
    <>
      {allStops.map((stop, index) => {
        const isCurrentStop = index === lastArrivedIndex;
        return (
          <BusStopRow
            // eslint-disable-next-line react/no-array-index-key -- index is required since the same stop can repeat
            key={index}
            stop={stop}
            index={index}
            allStopsLength={allStops.length}
            vehicleStatus={vehicleStatus}
            isCurrentStop={isCurrentStop}
            onEdit={openModalForStop}
          />
        );
      })}
      {travelDate && selectedStop && (
        <ChangeActualTime
          id={id}
          travelDate={travelDate}
          distributionStopReferences={distributionStopReferences}
          showModal={showModal}
          stop={selectedStop}
          closeModal={closeModal}
        />
      )}
    </>
  );
};
